// Module
var code = "<div class=\"radio-group\"> <div ng-repeat=\"(key, option) in to.options\" class=\"col-xs-3\"> <label class=\"checkbox-inline\"> <input type=\"checkbox\" id=\"{{id + '_'+ $index}}\" ng-model=\"multiCheckbox.checked[$index]\" ng-change=\"multiCheckbox.change()\"> {{option[to.labelProp || 'name']}} </label> </div> </div> ";
// Exports
var _module_exports = code;;
var path = 'ui-formly/types/multiCheckbox/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;